'use strict';

(function () {

  if (!customElements.get('sticky-atc-bar')) {

    class StickyAtcBar extends HTMLElement {

      constructor() {

        super();

        this.parent = this.closest('.sticky-atc-bar');

        this.select = this.querySelector('.atc-product-form .select');

        this.masterSelect = this.querySelector('.atc-product-form .select__select');

        this.formBtn = this.querySelector('.button-add-card');

        this.stickyForm = this.querySelector('.atc-product-form form');

        this.quantity = 1;

        this.unitPriceCents = null;

      }

      connectedCallback() {

        this.onVariantChange();

        this.subscribeToMainVariant();

        this.attachResizeHandler();

        this.markEmptyStrike();

        this.attachQuantitySync();

        this.syncButtonPrice();

        this.syncCheckoutButtonStyle();

        this.checkoutStyleTimer = window.setTimeout(() => this.syncCheckoutButtonStyle(), 500);

        this.setStickyBarHeight();

      }

      disconnectedCallback() {

        this.cleanup();

      }

      onVariantChange() {

        if (!this.select) return;

        this.variantSelectHandler = (event) => {

          this.updateMasterId(event);

          this.renderProductInfo();

        };

        this.select.addEventListener('change', this.variantSelectHandler);

      }

      subscribeToMainVariant() {

        if (

          typeof subscribe !== 'function' ||

          typeof PUB_SUB_EVENTS === 'undefined' ||

          !PUB_SUB_EVENTS.variantChange

        ) {

          return;

        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {

          const data = event?.data || {};

          const variantId =

            data.variant?.id ||

            data.variantId ||

            data.html?.querySelector?.('.main-product input[name="id"], product-info input[name="id"]')?.value;

          if (!variantId || !this.masterSelect) return;

          const nextValue = String(variantId);

          const hasMatchingOption = Array.from(this.masterSelect.options || []).some(

            (option) => String(option.value) === nextValue

          );

          if (!hasMatchingOption || String(this.masterSelect.value) === nextValue) {

            this.syncButtonPrice();

            return;

          }

          this.masterSelect.value = nextValue;

          this.masterSelect.dispatchEvent(new Event('change', { bubbles: true }));

        });

      }

      updateMasterId(event) {

        this.currentVariant = event.target.value;

      }

      renderProductInfo() {

        const requestedVariantId = this.currentVariant;

        if (!requestedVariantId) return;

        this.productRequestController?.abort();

        this.productRequestController = new AbortController();

        fetch(`${this.dataset.url}?variant=${requestedVariantId}`, {

          signal: this.productRequestController.signal,

        })

          .then((response) => response.text())

          .then((responseText) => {

            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const addButtonUpdated = html.querySelector('.main-product .product-form__submit');

            this.toggleAddButton(

              !addButtonUpdated || addButtonUpdated.hasAttribute('disabled'),

              window.variantStrings?.soldOut

            );

            const priceContainer = html.querySelector('.main-product .price__container');

            this.updatePrice(priceContainer);

          })

          .catch((error) => {

            if (error.name !== 'AbortError') console.error('Error:', error);

          });

      }

      toggleAddButton(disable = true, text, modifyClass = true) {

        const addButton = this.formBtn;

        if (!addButton) return;

        const addButtonText = addButton.querySelector(

          'span:not(.sticky-atc-button__price):not(.loading__spinner)'

        );

        if (disable) {

          addButton.setAttribute('disabled', 'disabled');

          if (text && addButtonText) addButtonText.textContent = text;

        } else {

          addButton.removeAttribute('disabled');

          if (addButtonText) {

            addButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';

          }

        }

        if (!modifyClass) return;

      }

      updatePrice(newPrice) {

        if (!newPrice) return;

        const oldPrice = this.querySelector('.price__container');

        if (!oldPrice) return;

        oldPrice.parentNode.replaceChild(newPrice, oldPrice);

        this.markEmptyStrike();

        this.syncButtonPrice();

        this.setStickyBarHeight();

      }

      getMainQuantityInput() {

        return Array.from(document.querySelectorAll('input[name="quantity"]')).find(

          (input) =>

            !this.contains(input) &&

            input.closest('.main-product, product-info, [id^="ProductInfo-"]')

        );

      }

      isMainQuantityInput(target) {

        return Boolean(

          target instanceof HTMLInputElement &&

          target.matches('input[name="quantity"]') &&

          !this.contains(target) &&

          target.closest('.main-product, product-info, [id^="ProductInfo-"]')

        );

      }

      normalizeQuantity(input) {

        const minimum = Math.max(1, Number.parseInt(input?.min || input?.dataset?.min || '1', 10) || 1);

        const rawValue = Number.parseInt(input?.value || String(minimum), 10);

        return Number.isFinite(rawValue) ? Math.max(minimum, rawValue) : minimum;

      }

      ensureStickyQuantityInput() {

        if (!this.stickyForm) return;

        let stickyQuantity = this.stickyForm.querySelector('input[name="quantity"]');

        if (!stickyQuantity) {

          stickyQuantity = document.createElement('input');

          stickyQuantity.type = 'hidden';

          stickyQuantity.name = 'quantity';

          this.stickyForm.appendChild(stickyQuantity);

        }

        stickyQuantity.value = String(this.quantity);

      }

      syncQuantityFromMain(input = this.getMainQuantityInput()) {

        this.quantity = this.normalizeQuantity(input);

        this.ensureStickyQuantityInput();

        this.syncButtonPrice();

      }

      attachQuantitySync() {

        this.mainQuantityHandler = (event) => {

          if (!this.isMainQuantityInput(event.target)) return;

          this.syncQuantityFromMain(event.target);

        };

        document.addEventListener('input', this.mainQuantityHandler, true);

        document.addEventListener('change', this.mainQuantityHandler, true);

        this.stickySubmitHandler = () => this.syncQuantityFromMain();

        this.stickyForm?.addEventListener('submit', this.stickySubmitHandler, true);

        this.syncQuantityFromMain();

      }

      parsePriceCents(priceText) {

        if (!priceText) return null;

        const compact = priceText.replace(/\s/g, '');

        const match = compact.match(/-?\d[\d.,]*/);

        if (!match) return null;

        let numberText = match[0];

        const lastComma = numberText.lastIndexOf(',');

        const lastDot = numberText.lastIndexOf('.');

        const decimalSeparator = lastComma > lastDot ? ',' : '.';

        const decimalIndex = numberText.lastIndexOf(decimalSeparator);

        const decimalDigits = decimalIndex >= 0 ? numberText.length - decimalIndex - 1 : 0;

        if (decimalDigits === 2) {

          const thousandsSeparator = decimalSeparator === ',' ? /\./g : /,/g;

          numberText = numberText.replace(thousandsSeparator, '').replace(decimalSeparator, '.');

        } else {

          numberText = numberText.replace(/[.,]/g, '');

        }

        const amount = Number.parseFloat(numberText);

        return Number.isFinite(amount) ? Math.round(amount * 100) : null;

      }

      getUnitPriceCents(priceElement) {

        if (!priceElement) return null;

        const storedUnitPrice = Number.parseInt(

          priceElement.dataset.stickyUnitPriceCents || '',

          10

        );

        if (Number.isFinite(storedUnitPrice)) return storedUnitPrice;

        const parsedUnitPrice = this.parsePriceCents(priceElement.textContent);

        if (parsedUnitPrice !== null) {

          priceElement.dataset.stickyUnitPriceCents = String(parsedUnitPrice);

        }

        return parsedUnitPrice;

      }

      formatMoney(cents) {

        const moneyFormat =

          window.theme?.moneyFormat ||

          window.money_format ||

          window.Shopify?.money_format;

        if (

          typeof window.Shopify?.formatMoney === 'function' &&

          typeof moneyFormat === 'string' &&

          moneyFormat.length

        ) {

          return window.Shopify.formatMoney(cents, moneyFormat);

        }

        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {

          style: 'currency',

          currency: window.Shopify?.currency?.active || 'USD',

        }).format(cents / 100);

      }

      syncButtonPrice() {
        const hideButtonPrice = window.matchMedia('(max-width: 749px)').matches;
        if (hideButtonPrice && this.formBtn) {
          this.formBtn.querySelectorAll('.sticky-atc-button__price').forEach((price) => price.remove());
        }


        const priceContainer = this.querySelector('.price__container');

        const priceWrapper = priceContainer?.closest('.price');

        if (!priceContainer) return;

        const salePrice = priceContainer.querySelector('.price__sale .price-item--sale, .price-item--sale');

        const regularPrice =

          priceContainer.querySelector('.price__regular .price-item--regular') ||

          Array.from(priceContainer.querySelectorAll('.price-item--regular')).find(

            (price) => !price.closest('.price__sale')

          );

        const isOnSale = Boolean(

          priceWrapper?.classList.contains('price--on-sale') ||

          priceWrapper?.classList.contains('has-strike')

        );

        const activePrice = isOnSale && salePrice ? salePrice : regularPrice || salePrice;

        const priceText = activePrice?.textContent?.replace(/\s+/g, ' ').trim();

        const parsedUnitPrice = this.getUnitPriceCents(activePrice);

        if (parsedUnitPrice !== null) this.unitPriceCents = parsedUnitPrice;

        if (this.formBtn && !hideButtonPrice) {

          let buttonPrice = this.formBtn.querySelector('.sticky-atc-button__price');

          if (!priceText) {

            if (buttonPrice) buttonPrice.hidden = true;

          } else {

            if (!buttonPrice) {

              buttonPrice = document.createElement('span');

              buttonPrice.className = 'sticky-atc-button__price';

              const spinner = this.formBtn.querySelector('.loading__spinner');

              this.formBtn.insertBefore(buttonPrice, spinner || null);

            }

            buttonPrice.textContent =

              this.unitPriceCents === null

                ? priceText

                : this.formatMoney(this.unitPriceCents * this.quantity);

            buttonPrice.hidden = false;

          }

        }

        priceContainer

          .querySelectorAll('.price-item--regular, .price-item--sale')

          .forEach((priceElement) => {

            const unitPriceCents = this.getUnitPriceCents(priceElement);

            if (unitPriceCents === null) return;

            priceElement.textContent = this.formatMoney(unitPriceCents * this.quantity);

          });

        let quantityLabel = priceContainer.querySelector('.sticky-atc-quantity');

        if (!quantityLabel) {

          quantityLabel = document.createElement('span');

          quantityLabel.className = 'sticky-atc-quantity';

          quantityLabel.setAttribute('aria-live', 'polite');

          priceContainer.appendChild(quantityLabel);

        }

        quantityLabel.textContent = `Qty: ${this.quantity}`;

        quantityLabel.setAttribute('aria-label', `Quantity: ${this.quantity}`);

      }

      syncCheckoutButtonStyle() {

        if (!this.formBtn) return;

        const checkoutButton = document.querySelector(

          '#CartDrawer-Checkout, cart-drawer button[name="checkout"], cart-drawer .cart__checkout-button, #CartDrawer .cart__checkout-button'

        );

        if (!checkoutButton) return;

        const checkoutStyle = window.getComputedStyle(checkoutButton);

        const styleProperties = [

          '--color-button',

          '--color-button-text',

          '--color-button-outline',

          '--color-button-hover',

          '--color-button-text-hover',

          '--color-button-outline-hover',

          '--buttons-radius',

          '--buttons-radius-hover',

          '--buttons-border-width',

          '--buttons-shadow-opacity',

          '--buttons-shadow-horizontal-offset',

          '--buttons-shadow-vertical-offset',

          '--buttons-shadow-blur-radius',

          '--button-height',

          '--gradient-background',

          'height',

          'min-height',

          'padding-top',

          'padding-right',

          'padding-bottom',

          'padding-left',

          'background-color',

          'background-image',

          'background-position',

          'background-size',

          'border-top-width',

          'border-right-width',

          'border-bottom-width',

          'border-left-width',

          'border-top-style',

          'border-right-style',

          'border-bottom-style',

          'border-left-style',

          'border-top-color',

          'border-right-color',

          'border-bottom-color',

          'border-left-color',

          'border-top-left-radius',

          'border-top-right-radius',

          'border-bottom-right-radius',

          'border-bottom-left-radius',

          'box-shadow',

          'color',

        ];

        styleProperties.forEach((property) => {

          const value = checkoutStyle.getPropertyValue(property);

          if (value) this.formBtn.style.setProperty(property, value, 'important');

        });

      }

      markEmptyStrike() {

        const wrapper = this.querySelector('.price');

        if (!wrapper) return;

        const strike = wrapper.querySelector('.price__sale .price-item--regular');

        if (!strike) return;

        const isEmpty = (strike.textContent || '').trim().length === 0;

        strike.classList.toggle('is-empty', isEmpty);

        const spanWrap = strike.closest('span');

        if (spanWrap) {

          spanWrap.classList.toggle('is-empty', isEmpty);

          spanWrap.style.display = isEmpty ? 'none' : '';

        }

        wrapper.classList.toggle('has-strike', !isEmpty);

      }

      setStickyBarHeight() {

        const height = this.parent ? this.parent.offsetHeight : 0;

        document.documentElement.style.setProperty('--atc-bar-height', `${height}px`);

      }

      attachResizeHandler() {

        this.resizeObserver = new ResizeObserver(() => this.setStickyBarHeight());

        this.resizeObserver.observe(this);

        this.resizeHandler = () => {
          this.syncButtonPrice();
          this.setStickyBarHeight();
        };

        window.addEventListener('resize', this.resizeHandler, { passive: true });

      }

      cleanup() {

        if (this.select && this.variantSelectHandler) {

          this.select.removeEventListener('change', this.variantSelectHandler);

        }

        if (this.mainQuantityHandler) {

          document.removeEventListener('input', this.mainQuantityHandler, true);

          document.removeEventListener('change', this.mainQuantityHandler, true);

        }

        if (this.stickyForm && this.stickySubmitHandler) {

          this.stickyForm.removeEventListener('submit', this.stickySubmitHandler, true);

        }

        this.variantChangeUnsubscriber?.();

        this.productRequestController?.abort();

        if (this.checkoutStyleTimer) window.clearTimeout(this.checkoutStyleTimer);

        this.resizeObserver?.disconnect();

        if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);

      }

    }

    customElements.define('sticky-atc-bar', StickyAtcBar);

    function checkBarVisibility() {

      const stickyAtcBar = document.querySelector('.sticky-atc-bar');

      const productVisible = document.querySelector('.product .product__info-wrapper');

      if (!stickyAtcBar || !productVisible) return;

      if (window.__stickyAtcVisibilityHandler) {

        document.removeEventListener('scroll', window.__stickyAtcVisibilityHandler);

        window.removeEventListener('resize', window.__stickyAtcVisibilityHandler);

      }

      const updateVisibility = () => {

        const scrolled = document.scrollingElement?.scrollTop || window.scrollY || 0;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        const threshold = isMobile ? 0 : productVisible.offsetHeight / 2;

        const shouldShow = scrolled > threshold && !stickyAtcBar.classList.contains('js-hidden');

        stickyAtcBar.classList.toggle('atc-visible', shouldShow);

      };

      window.__stickyAtcVisibilityHandler = updateVisibility;

      updateVisibility();

      document.addEventListener('scroll', updateVisibility, { passive: true });

      window.addEventListener('resize', updateVisibility, { passive: true });

    }

    document.addEventListener('DOMContentLoaded', checkBarVisibility);

    document.addEventListener('shopify:section:load', checkBarVisibility);

    function addStickySpace() {

      const checkMobileStickyBar = document.querySelector('.mobile-sticky-bar');

      const stickyAtcBar = document.querySelector('.sticky-atc-bar');

      if (!stickyAtcBar) return;

      const style = stickyAtcBar.dataset.style;

      const bottom =

        style === 'default' || style === 'default-swatches' || window.innerWidth < 750 ? 0 : 15;

      if (

        window.innerWidth < 750 &&

        checkMobileStickyBar?.classList.contains('active')

      ) {

        stickyAtcBar.style.bottom = `${checkMobileStickyBar.offsetHeight + bottom}px`;

      } else {

        stickyAtcBar.style.bottom = `${bottom}px`;

      }

    }

    document.addEventListener('DOMContentLoaded', addStickySpace);

    document.addEventListener('shopify:section:load', addStickySpace);

    window.addEventListener('resize', addStickySpace, { passive: true });

    window.addEventListener('scroll', addStickySpace, { passive: true });

    const stickyAtcSelect = document.querySelector('sticky-atc-bar .select__select');

    const atcImage = document.querySelector('sticky-atc-bar img');

    if (stickyAtcSelect) {

      stickyAtcSelect.addEventListener('change', function () {

        const getNewImage = stickyAtcSelect.options[this.selectedIndex]?.getAttribute('data-media');

        if (getNewImage && atcImage) atcImage.src = getNewImage;

      });

    }

  }

  if (!customElements.get('sticky-atc-variants')) {

    class StickyAtcVariants extends HTMLElement {

      constructor() {

        super();

        this.handleSwatchClick = this.handleSwatchClick.bind(this);

        this.handleSwatchKeydown = this.handleSwatchKeydown.bind(this);

      }

      connectedCallback() {

        this.init();

      }

      disconnectedCallback() {

        this.cleanup();

      }

      init() {

        this.productCard = this.closest('sticky-atc-bar');

        if (!this.productCard) return;

        this.url = this.productCard.dataset.url || '';

        this.select = this.productCard.querySelector('.select__select');

        this.cardColorSwatches = [...this.querySelectorAll('.card-variant')];

        if (!this.cardColorSwatches.length || !this.select) return;

        this.currentId = this.select.value || this.cardColorSwatches[0]?.dataset.variantId;

        this.cardColorSwatches.forEach((swatch) => {

          swatch.addEventListener('click', this.handleSwatchClick);

          swatch.addEventListener('keydown', this.handleSwatchKeydown);

        });

        this.addActiveState();

      }

      handleSwatchClick(event) {

        event.preventDefault();

        event.stopPropagation();

        this.updateActiveSwatch(event.currentTarget);

      }

      handleSwatchKeydown(event) {

        if (event.key === 'Enter' || event.key === ' ') {

          event.preventDefault();

          this.updateActiveSwatch(event.currentTarget);

        }

      }

      updateActiveSwatch(swatch) {

        const { variantId } = swatch.dataset;

        if (!variantId || this.checkCurrentVariant(variantId)) return;

        const matchingOption = Array.from(this.select.options).find(

          (option) => option.value === variantId

        );

        if (matchingOption) {

          this.select.value = variantId;

          this.select.dispatchEvent(new Event('change', { bubbles: true }));

        }

        this.addActiveState();

      }

      addActiveState() {

        let foundActive = false;

        this.cardColorSwatches.forEach((swatch) => {

          const { variantId } = swatch.dataset;

          const isActive = variantId === this.select.value && !foundActive;

          swatch.classList.toggle('active', isActive);

          if (isActive) foundActive = true;

        });

      }

      checkCurrentVariant(id) {

        if (this.currentId === id) return true;

        this.currentId = id;

        return false;

      }

      cleanup() {

        this.cardColorSwatches?.forEach((swatch) => {

          swatch.removeEventListener('click', this.handleSwatchClick);

          swatch.removeEventListener('keydown', this.handleSwatchKeydown);

        });

      }

    }

    customElements.define('sticky-atc-variants', StickyAtcVariants);

  }

  function initializeCloseButton() {

    const stickyAtcBtn = document.querySelector('.sticky-atc-bar__close');

    if (!stickyAtcBtn || stickyAtcBtn.dataset.listenerAttached === 'true') return;

    stickyAtcBtn.dataset.listenerAttached = 'true';

    stickyAtcBtn.addEventListener('click', () => {

      const stickyAtcBar = document.querySelector('.sticky-atc-bar');

      if (!stickyAtcBar) return;

      stickyAtcBar.classList.add('js-hidden');

      stickyAtcBar.classList.remove('atc-visible');

    });

  }

  document.addEventListener('DOMContentLoaded', initializeCloseButton);

  document.addEventListener('shopify:section:load', initializeCloseButton);

})();
